<template>
  <v-col class="py-0" cols="4">
    <v-row style="margin: 0; margin-left: -12px; margin-right: -12px">
      <v-col class="py-0">
        <v-autocomplete
          hide-details
          :items="fromPlaces"
          item-value="short_name"
          :item-text="item => item.short_name"
          :filter="
            (item, query) =>
              item.short_name.toLowerCase().includes(query.toLowerCase()) ||
              item.stop_name.toLowerCase().includes(query.toLowerCase())
          "
          label="Från"
          :rules="[
            (!isChecked && validatingForm) || isCancelStopCanceled
              ? () => true
              : required
          ]"
          :loading="$apollo.loading"
          v-model="replacement_from_place"
          :append-icon="
            isDiff('replacement_from_place')
              ? 'mdi-alert-octagram'
              : 'mdi-menu-down'
          "
          :disabled="item.missing || isHistoryEvent || isCancelStopCanceled"
        />
      </v-col>
      <v-col class="py-0">
        <v-autocomplete
          hide-details
          :items="toPlaces"
          item-value="short_name"
          :item-text="item => item.short_name"
          :filter="
            (item, query) =>
              item.short_name.toLowerCase().includes(query.toLowerCase()) ||
              item.stop_name.toLowerCase().includes(query.toLowerCase())
          "
          label="Till"
          :rules="[
            (!isChecked && validatingForm) || isCancelStopCanceled
              ? () => true
              : required
          ]"
          :loading="$apollo.loading"
          v-model="replacement_to_place"
          :append-icon="
            isDiff('replacement_to_place')
              ? 'mdi-alert-octagram'
              : 'mdi-menu-down'
          "
          :disabled="item.missing || isHistoryEvent || isCancelStopCanceled"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { required } from '@/common/validationRules'
import gql from 'graphql-tag'
import { get } from 'vuex-pathify'
import { format } from 'date-fns'

const getSet = prop => ({
  get() {
    return this.form[this.uuid].data[prop]
  },

  set(v) {
    let value = v
    if (!value || !value.length) {
      value = null
    }
    const form = Object.assign({}, this.form)
    form[this.uuid].data[prop] = value
    this.$store.dispatch('duaMessage/updateForm', {
      uuid: this.uuid,
      prop,
      value
    })
  }
})

const INSTÄLLT_CANCELATION_CODE = 'ANA027'

export default {
  name: 'DuaMessageRouteField',

  props: {
    item: Object,
    uuid: String,
    validatingForm: Boolean
  },

  apollo: {
    searchTrain: {
      query: gql`
        query searchTrain($filter: SearchTrainInput!) {
          searchTrain(filter: $filter) {
            public_number
            places {
              advertised
              location
              location_long_name
            }
          }
        }
      `,
      variables() {
        return {
          filter: {
            train_number: this.item.text.train_number,
            date: format(new Date(this.item.text.departure), 'yyyy-MM-dd')
          }
        }
      }
    }
  },

  data() {
    return { required }
  },

  watch: {
    'model.from'() {
      this.replacement_to_place = null
    }
  },

  created() {
    if (
      (this.replacement_to_place === null ||
        this.replacement_from_place === null) &&
      ['CANCELED', 'PARTIAL_CANCELLATION'].includes(
        this.item.text.deviation_type
      )
    ) {
      this.replacement_to_place = this.item.text.to
      this.replacement_from_place = this.item.text.from
    }
  },

  methods: {
    isDiff(prop) {
      if (!this.currentTrip) return false
      const currentProp = this.currentTrip.data[prop] || null
      const formProp = this.form[this.uuid].data[prop] || null
      return currentProp !== formProp
    }
  },

  computed: {
    isHistoryEvent: get('history/isHistoryEvent'),
    stops: get('event/stops'),
    form: get('duaMessage/form'),
    model: get('duaMessage/model'),

    isCancelStop() {
      return ['CANCELED_STOP'].includes(this.item.text.deviation_type)
    },

    isCancelStopCanceled() {
      return (
        this.isCancelStop &&
        this.dua_cancellation_code === INSTÄLLT_CANCELATION_CODE
      )
    },

    dua_cancellation_code: {
      ...getSet('dua_cancellation_code')
    },

    replacement_from_place: {
      ...getSet('replacement_from_place')
    },

    replacement_to_place: {
      ...getSet('replacement_to_place')
    },

    isChecked() {
      return this.form[this.uuid]._checked
    },

    currentTrip() {
      return this.model?.body?.find(x => x?.trip_uuid === this.uuid)
    },

    isAdvertisedPlaces() {
      return (
        this.item.text.type === 'RST' &&
        this.searchTrain &&
        this.searchTrain.places.length
      )
    },

    places() {
      return this.isAdvertisedPlaces
        ? this.searchTrain.places
            .map(x => ({
              advertised: x.advertised,
              short_name: x.location,
              stop_name: x.location_long_name
            }))
            .sort((a, b) => +new Date(a.advertised) - +new Date(b.advertised))
        : this.stops
    },

    fromPlaces() {
      return this.places
    },

    toPlaces() {
      if (!this.isAdvertisedPlaces || !this.replacement_from_place)
        return this.places
      const splitIndex = this.places.findIndex(
        x => x.short_name === this.replacement_from_place
      )
      return this.places.slice(splitIndex)
    }
  }
}
</script>
